import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from "react";
import FullPageLoader from "../components/Loading/FullPageLoading";

const LoadingContext = createContext({
  loadingCount: 0,
  isLoading: false,
  startLoading: () => {},
  stopLoading: () => {},
  withLoading: async (promiseOrFn) => promiseOrFn,
});

export const LoadingProvider = ({ children }) => {
  const [loadingCount, setLoadingCount] = useState(0);
  const isUnmountedRef = useRef(false);

  const startLoading = useCallback(() => {
    setLoadingCount((prev) => prev + 1);
  }, []);

  const stopLoading = useCallback(() => {
    setLoadingCount((prev) => (prev > 0 ? prev - 1 : 0));
  }, []);

  const withLoading = useCallback(async (promiseOrFn) => {
    startLoading();
    try {
      if (typeof promiseOrFn === "function") {
        return await promiseOrFn();
      }
      return await promiseOrFn;
    } finally {
      if (!isUnmountedRef.current) {
        stopLoading();
      }
    }
  }, [startLoading, stopLoading]);

  const isLoading = loadingCount > 0;
  
  const value = useMemo(() => ({ loadingCount, isLoading, startLoading, stopLoading, withLoading }), [loadingCount, isLoading, startLoading, stopLoading, withLoading]);

  return (
    <LoadingContext.Provider value={value}>
      {children}
      {loadingCount > 0 ? <FullPageLoader /> : null}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);


